export function getRoot(state) {
  return state
}



// WEBPACK FOOTER //
// ./src/stores/rootSelector.js